import CloseIcon from "@mui/icons-material/Close";
import { services } from "../../../constants/customer";
import { Player } from "@lottiefiles/react-lottie-player";
import notFound from "../../../assets/animation/notFount.json";

function ServiceSelection({ onClose, onSubmit, dialogDetails }) {
  return (
    <div className="relative p-6 sm:py-16 sm:px-8 overflow-y-auto max-h-[90vh]">
      <button
        className="absolute top-4 right-4 text-gray-600 hover:text-black"
        onClick={onClose}
        aria-label="Close"
      >
        <CloseIcon />
      </button>
      <div className="flex flex-col justify-center items-center ">
        <div className="text-[#101828] font-[700] text-2xl mb-1">
          Schedule Pickup for?
        </div>
        <div className="font-medium text-[var(--text-pr)] text-sm mb-6 text-center px-12">
          Select any one of the services to schedule your pickup
        </div>
        <div className="flex justify-center items-center flex-wrap xl:flex-nowrap gap-6">
          {dialogDetails?.selected_services?.length > 0 ? (
            services
              .filter((service) =>
                dialogDetails?.selected_services?.includes(service.title)
              )
              .map((service) => (
                <div
                  key={service.title}
                  onClick={() => onSubmit(service.title)}
                  className="flex flex-col items-center gap-4 cursor-pointer hover:scale-105 transition"
                >
                  <div className="w-24 h-24 md:w-36 md:h-36 rounded-full border-2 border-[var(--service-border)] bg-[var(--service-bg)] hover:bg-[var(--service-hover-bg)] flex items-center justify-center">
                    <img
                      src={service.icon}
                      alt={service.title}
                      className="w-16 h-16 md:w-28 md:h-28 object-contain"
                    />
                  </div>
                  <span className="text-[var(--text-pr)] text-sm md:text-lg font-medium">
                    {service.title}
                  </span>
                </div>
              ))
          ) : (
             <div className="flex flex-col bg-white items-center justify-center  text-gray-500">
            <Player
              autoplay
              loop
              src={notFound}
              style={{ height: "100px", width: "100px" }}
            />
            <p className="text-center text-xs md:text-sm">
               No services available for scheduling.
            </p>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ServiceSelection;
